import { DamageTypeTruckEnum } from "@/store/enum/damageType.enum";

const bumperRear =
  "M2200 1799.85C2154.94 1799.85 2118.42 1837.3 2118.42 1883.5 2118.42 1895.05 2120.7 1906.05 2124.83 1916.06L2129.67 1923.43 2096.39 2398 2303.61 2398 2270.32 1923.43 2275.17 1916.06C2279.3 1906.05 2281.58 1895.05 2281.58 1883.5 2281.58 1837.3 2245.06 1799.85 2200 1799.85ZM1908 1369 2492 1369 2492 2398 1908 2398Z";
const roof =
  "M1856.22 899.207 1856.05 900.331C1854.73 900.369 1854.71 900.045 1855.68 899.45ZM2543.78 899.207 2544.32 899.45C2545.29 900.045 2545.27 900.369 2543.95 900.331ZM1888.02 855.52C1888.82 855.533 1889.98 855.563 1891.26 855.583L1894.44 855.594 1891.92 855.987 1889.64 855.805C1886.29 855.524 1886.42 855.492 1888.02 855.52ZM2511.98 855.52C2513.58 855.492 2513.71 855.524 2510.36 855.805L2508.08 855.987 2505.53 855.589ZM2501.17 854.908 2505.53 855.589 2504.85 855.596C2502.37 855.557 2500.47 855.39 2501.17 854.908ZM1898.83 854.908C1899.53 855.39 1897.63 855.557 1895.15 855.596L1894.44 855.594ZM2200.87 750C2309.73 750 2403.14 758.008 2443.03 769.421L2449.58 771.583 2449.65 771.587C2452.16 772.053 2454.46 772.836 2456.57 773.893L2458.18 775.31 2458.35 775.39C2460.1 776.425 2461.43 777.479 2462.33 778.547L2462.61 779.204 2467.1 783.16C2484.24 806.839 2479.67 857.135 2487.8 857.58 2493.99 857.097 2498.79 856.724 2502.46 856.436L2508.08 855.987 2519.15 857.718C2548.96 866.311 2544.11 890.907 2543.64 898.251L2543.78 899.207 2538.79 896.939C2528.37 892.748 2507.48 885.662 2497.06 881.47L2491.91 879.126 2491.91 878.078C2490.58 878.04 2490.57 878.364 2491.54 878.96L2491.91 879.126 2491.91 1369 2469.22 1369 2469.22 1369 1928.47 1369 1928.47 1369 1908.09 1369 1908.09 879.126 1908.46 878.96C1909.43 878.365 1909.42 878.04 1908.09 878.078L1908.09 879.126 1902.94 881.47C1892.52 885.662 1871.63 892.748 1861.21 896.939L1856.22 899.207 1856.36 898.251C1855.89 890.907 1851.05 866.311 1880.85 857.718L1891.92 855.987 1897.54 856.436C1901.21 856.724 1906.01 857.097 1912.2 857.58 1922.36 857.023 1912.68 778.576 1950.35 771.587L1952.46 771.484 1958.7 769.421C1998.59 758.008 2092 750 2200.87 750Z";
const tireFrontLeft =
  "M1058.5 980C1131.13 980 1190 1038.87 1190 1111.5 1190 1184.13 1131.13 1243 1058.5 1243 985.875 1243 927 1184.13 927 1111.5 927 1038.87 985.875 980 1058.5 980Z";
const tireMiddleLeft =
  "M1058.5 1750C1131.13 1750 1190 1808.65 1190 1881 1190 1953.35 1131.13 2012 1058.5 2012 985.874 2012 927 1953.35 927 1881 927 1808.65 985.874 1750 1058.5 1750Z";
const tireRearLeft =
  "M1058.5 2077C1131.13 2077 1190 2135.65 1190 2208 1190 2280.35 1131.13 2339 1058.5 2339 985.874 2339 927 2280.35 927 2208 927 2135.65 985.874 2077 1058.5 2077Z";
const sidepanleRearLeft =
  "M1467.41 1113.8 1468.47 1118.36C1475.85 1146.75 1485.03 1175.35 1496.82 1204.56 1531.51 1220.3 1597.34 1216.44 1610.68 1204.56 1614.13 1196.26 1615.2 1163.66 1615.11 1120.28L1615.06 1113.8ZM1627 1065 1627 1065 1625.81 1066.77 1625.81 1373.08 1190.05 1378.25 1190.05 1790.79 1192.18 1793.86C1206.33 1818.7 1214.58 1848.64 1214.58 1880.86 1214.58 1913.09 1206.33 1943.03 1192.18 1967.87L1190.05 1970.94 1190.05 2119.17 1192.18 2122.24C1206.33 2147.08 1214.58 2177.02 1214.58 2209.24 1214.58 2241.47 1206.33 2271.41 1192.18 2296.24L1190.05 2299.32 1190.05 2397 1012 2397 1012 2335.86 1031.45 2341.9C1040.32 2343.72 1049.5 2344.67 1058.9 2344.67 1134.12 2344.67 1195.09 2283.64 1195.09 2208.34 1195.09 2133.05 1134.12 2072.01 1058.9 2072.01 1049.5 2072.01 1040.32 2072.96 1031.45 2074.78L1012 2080.82 1012 2008.38 1031.45 2014.43C1040.32 2016.24 1049.5 2017.2 1058.9 2017.2 1134.12 2017.2 1195.09 1956.16 1195.09 1880.86 1195.09 1805.57 1134.12 1744.53 1058.9 1744.53 1049.5 1744.53 1040.32 1745.49 1031.45 1747.3L1012 1753.35 1012 1378.25 1012 1265.98C1043.78 1265.98 1075.56 1265.98 1107.34 1265.98 1179.77 1265.98 1238.49 1196.75 1238.49 1111.35L1236.14 1083.88 1583.72 1083.88 1593.64 1083.88C1604.83 1083.88 1614.95 1079.34 1622.28 1072.01Z";
const doorFrontLeft =
  "M1428.88 857.851C1436.9 919.335 1442.24 976.816 1451.49 1033.52L1454.51 1050.03 1615.29 1061.64 1614.59 1023.3C1613.5 971.627 1612.07 918.201 1611.51 876.537ZM1034.21 841 1594.45 841C1616.84 841 1635 859.133 1635 881.501L1635 1043.5C1635 1065.87 1616.84 1084 1594.45 1084L1236.45 1084 1236.13 1080.31C1223.89 1009.91 1170.94 956.956 1107.47 956.956L1012 956.956C1013.89 920.106 1027.23 936.757 1033.84 905.559Z";
const fenderFrontLeft =
  "M1626 767.539 1626 857.711 1622.47 852.496C1615.14 845.193 1605.01 840.676 1593.83 840.676L1034.24 840.676 1034 882 1034 882 1034.67 764.209C1043.46 751.47 1043.78 751.874 1068.59 750.401L1190.14 751.067C1236.94 754.196 1346.57 747.226 1384.26 751.34 1408.76 752.637 1408.67 757.174 1416.3 775.747 1474.4 772.618 1541.93 782.632 1599.1 789.829 1599.1 777.781 1602.68 778.401 1600.31 761.979 1606.51 762.945 1611.84 763.905 1616.44 764.914Z";
const roofLeft =
  "M1870 1327.18C1861.97 1347.47 1837.94 1354.68 1790.33 1371.05L1626 1373 1626 1066.64 1631.16 1058.99C1633.22 1054.14 1634.35 1048.81 1634.35 1043.21L1634.35 881.028C1634.35 875.43 1633.22 870.097 1631.16 865.246L1626 857.597 1626 767 1626 767 1628.18 767.6C1647.81 774.579 1645.69 785.214 1650.28 811.023 1666.1 828.114 1671.18 822.474 1688.03 855.052 1707.55 896.388 1713.9 992.829 1730.85 1077.75 1812.02 1135.06 1866.18 1275.17 1870 1327.18Z";
const engingeHood =
  "M1958.24 460.461C1942.23 460.461 1929.24 473.446 1929.24 489.465L1929.24 605.479C1929.24 621.498 1942.23 634.483 1958.24 634.483L2441.76 634.483C2457.77 634.483 2470.76 621.498 2470.76 605.479L2470.76 489.465C2470.76 473.446 2457.77 460.461 2441.76 460.461ZM2301.65 405.427C2296.46 405.427 2292.26 409.63 2292.26 414.814L2292.26 424.999C2293.87 430.183 2298.61 435.459 2304.87 438.141 2324.72 444.042 2352.07 442.433 2377.29 442.433 2382.47 442.433 2386.67 438.23 2386.67 433.047L2386.67 414.814C2386.67 409.63 2382.47 405.427 2377.29 405.427ZM2024.32 405.427C2019.14 405.427 2014.94 409.63 2014.94 414.814L2014.94 433.046C2014.94 438.23 2019.14 442.433 2024.32 442.433 2049.54 442.433 2076.89 444.042 2096.74 438.141 2103 435.459 2107.74 430.183 2109.35 424.999L2109.35 414.814C2109.35 409.63 2105.14 405.427 2099.96 405.427ZM2012.03 354.936C2010.68 354.936 2009.57 356.038 2009.57 357.396L2009.57 367.231C2009.57 368.589 2010.68 369.69 2012.03 369.69L2387.97 369.69C2389.32 369.69 2390.43 368.589 2390.43 367.231L2390.43 357.396C2390.43 356.038 2389.32 354.936 2387.97 354.936ZM2012.03 323.853C2010.67 323.853 2009.57 324.954 2009.57 326.312L2009.57 336.147C2009.57 337.505 2010.67 338.606 2012.03 338.606L2387.97 338.606C2389.32 338.606 2390.43 337.505 2390.43 336.147L2390.43 326.312C2390.43 324.954 2389.32 323.853 2387.97 323.853ZM2012.03 292.769C2010.67 292.769 2009.57 293.87 2009.57 295.228L2009.57 305.063C2009.57 306.421 2010.67 307.522 2012.03 307.522L2387.97 307.522C2389.32 307.522 2390.43 306.421 2390.43 305.063L2390.43 295.228C2390.43 293.87 2389.32 292.769 2387.97 292.769ZM2391.95 112.392C2389.03 112.392 2386.67 114.754 2386.67 117.668L2386.67 138.769C2386.67 141.683 2389.03 144.045 2391.95 144.045L2441.47 144.045C2444.39 144.045 2446.75 141.683 2446.75 138.769L2446.75 117.668C2446.75 114.754 2444.39 112.392 2441.47 112.392ZM1961.74 112.392C1958.83 112.392 1956.47 114.754 1956.47 117.668L1956.47 138.769C1956.47 141.683 1958.83 144.044 1961.74 144.044L2011.27 144.044C2014.19 144.044 2016.55 141.683 2016.55 138.769L2016.55 117.668C2016.55 114.754 2014.19 112.392 2011.27 112.392ZM1957.22 77 2442.78 77C2468.86 77 2490 98.1419 2490 124.222L2490 606.778C2490 632.858 2468.86 654 2442.78 654L1957.22 654C1931.14 654 1910 632.858 1910 606.778L1910 124.222C1910 98.1419 1931.14 77 1957.22 77Z";
const windshield =
  "M1929 489.167C1929 473.058 1942.06 460 1958.17 460L2441.83 460C2457.94 460 2471 473.058 2471 489.167L2471 605.833C2471 621.941 2457.94 635 2441.83 635L1958.17 635C1942.06 635 1929 621.941 1929 605.833Z";
const leftMirror =
  "M1859 480.5C1859 475.806 1862.81 472 1867.5 472L1901.5 472C1906.19 472 1910 475.806 1910 480.5L1910 566.5C1910 571.194 1906.19 575 1901.5 575L1867.5 575C1862.81 575 1859 571.194 1859 566.5Z";
const rightMirror =
  "M2490 480.5C2490 475.806 2493.81 472 2498.5 472L2532.5 472C2537.19 472 2541 475.806 2541 480.5L2541 566.5C2541 571.194 2537.19 575 2532.5 575L2498.5 575C2493.81 575 2490 571.194 2490 566.5Z";
const tireFrontRight =
  "M0 131.5C-3.34834e-14 58.8745 58.8745-1.67417e-14 131.5-1.67417e-14 204.125-3.34834e-14 263 58.8745 263 131.5 263 204.125 204.125 263 131.5 263 58.8745 263-6.69668e-14 204.125 0 131.5Z";
const tireMiddleRight =
  "M0 131.5C-3.33561e-14 58.8745 58.6507-1.67417e-14 131-1.67417e-14 203.349-3.34834e-14 262 58.8745 262 131.5 262 204.125 203.349 263 131 263 58.6507 263-6.67122e-14 204.125 0 131.5Z";

const tireRearRight =
  "M0 131.5C-3.33561e-14 58.8745 58.6507-1.67417e-14 131-1.67417e-14 203.349-3.34834e-14 262 58.8745 262 131.5 262 204.125 203.349 263 131 263 58.6507 263-6.67122e-14 204.125 0 131.5Z";
const sidepanelRearRight =
  "M48.8013 159.586 53.3579 158.532C81.7494 151.149 110.35 141.974 139.563 130.185 155.298 95.4912 151.438 29.6559 139.563 16.3164 131.258 12.8687 98.6553 11.7983 55.2814 11.8852L48.8013 11.9446ZM0 0 0.00036089 0 1.76728 1.1901 308.076 1.1901 313.253 436.951 725.793 436.951 728.864 434.815C753.699 420.674 783.637 412.417 815.864 412.417 848.092 412.417 878.031 420.674 902.865 434.815L905.937 436.951 1054.17 436.951 1057.24 434.815C1082.08 420.674 1112.02 412.417 1144.24 412.417 1176.47 412.417 1206.41 420.674 1231.24 434.815L1234.32 436.951 1332 436.951 1332 615 1270.86 615 1276.9 595.55C1278.72 586.685 1279.67 577.505 1279.67 568.102 1279.67 492.884 1218.64 431.907 1143.34 431.907 1068.05 431.907 1007.01 492.884 1007.01 568.102 1007.01 577.505 1007.96 586.685 1009.78 595.55L1015.82 615 943.383 615 949.427 595.55C951.243 586.685 952.197 577.505 952.197 568.102 952.197 492.884 891.159 431.907 815.864 431.907 740.571 431.907 679.533 492.884 679.533 568.102 679.533 577.505 680.486 586.685 682.302 595.55L688.346 615 313.253 615 200.977 615C200.977 583.221 200.977 551.441 200.977 519.662 200.977 447.229 131.747 388.511 46.3462 388.511L18.8799 390.859 18.8799 43.2795 18.8799 33.356C18.8799 22.1728 14.3425 12.0481 7.00631 4.71931Z";
const doorFrontRight =
  "M16.8507 206.122C78.3351 198.103 135.816 192.757 192.517 183.513L209.031 180.49 220.636 19.7071 182.302 20.4111C130.627 21.5005 77.2009 22.9342 35.5365 23.4913ZM0 600.795 0 40.5546C0 18.1569 18.1328 0 40.5008 0L202.499 0C224.867 0 243 18.1569 243 40.5546L243 398.55 239.306 398.867C168.91 411.113 115.956 464.064 115.956 527.53L115.956 623C79.1058 621.113 95.7563 607.765 64.5587 601.161Z";
const fenderFrontRight =
  "M17.5395 0 107.711 0 102.496 3.52924C95.1928 10.8596 90.6757 20.9865 90.6757 32.1724L90.6757 591.764 132 592 132 592 14.2092 591.329C1.47023 582.536 1.8743 582.225 0.400718 557.413L1.06672 435.856C4.19595 389.056-2.77375 279.435 1.33954 241.743 2.63664 217.243 7.17384 217.327 25.7473 209.705 22.6181 151.596 32.6316 84.065 39.8289 26.8989 27.7814 26.8992 28.4005 23.3175 11.9788 25.6947 12.9445 19.4939 13.9051 14.1587 14.9137 9.55763Z";
const roofRight =
  "M560.175 0C580.468 8.0281 587.683 32.0559 604.052 79.6736L606 244 299.639 244 291.991 238.837C287.14 236.782 281.807 235.646 276.209 235.646L114.028 235.646C108.43 235.646 103.097 236.782 98.246 238.837L90.5978 244 0.000280567 244 0 244 0.600132 241.821C7.57923 222.19 18.2144 224.308 44.0237 219.719 61.1147 203.899 55.4745 198.817 88.0519 181.97 129.389 162.447 225.829 156.102 310.752 139.154 368.06 57.9807 508.174 3.81781 560.175 0Z";

export default {
  g: {
    path: [
      {
        "-id": "1",
        "-title": DamageTypeTruckEnum.bumperRear,
        "-class": "land",
        "-fill": "#888888",
        "-d": bumperRear,
        "-self-closing": "true"
      },
      {
        "-id": "2",
        "-title": DamageTypeTruckEnum.roof,
        "-class": "land",
        "-fill": "#888888",
        "-d": roof,
        "-self-closing": "true"
      },
      {
        "-id": "3",
        "-title": DamageTypeTruckEnum.tireFrontLeft,
        "-class": "land",
        "-fill": "#888888",
        "-d": tireFrontLeft,
        "-self-closing": "true"
      },
      {
        "-id": "4",
        "-title": DamageTypeTruckEnum.tireMiddleLeft,
        "-class": "land",
        "-fill": "#888888",
        "-d": tireMiddleLeft,
        "-self-closing": "true"
      },
      {
        "-id": "5",
        "-title": DamageTypeTruckEnum.tireRearLeft,
        "-class": "land",
        "-fill": "#888888",
        "-d": tireRearLeft,
        "-self-closing": "true"
      },
      {
        "-id": "6",
        "-title": DamageTypeTruckEnum.sidepanleRearLeft,
        "-class": "land",
        "-fill": "#888888",
        "-d": sidepanleRearLeft,
        "-self-closing": "true"
      },
      {
        "-id": "7",
        "-title": DamageTypeTruckEnum.doorFrontLeft,
        "-class": "land",
        "-fill": "#888888",
        "-d": doorFrontLeft,
        "-self-closing": "true"
      },
      {
        "-id": "8",
        "-title": DamageTypeTruckEnum.fenderFrontLeft,
        "-class": "land",
        "-fill": "#888888",
        "-d": fenderFrontLeft,
        "-self-closing": "true"
      },
      {
        "-id": "9",
        "-title": DamageTypeTruckEnum.roof,
        "-class": "land",
        "-fill": "#888888",
        "-d": roofLeft,
        "-self-closing": "true"
      },
      {
        "-id": "10",
        "-title": DamageTypeTruckEnum.engingeHood,
        "-class": "land",
        "-fill": "#888888",
        "-d": engingeHood,
        "-self-closing": "true"
      },
      {
        "-id": "11",
        "-title": DamageTypeTruckEnum.windshield,
        "-class": "land",
        "-fill": "#888888",
        "-d": windshield,
        "-self-closing": "true"
      },
      {
        "-id": "12",
        "-title": DamageTypeTruckEnum.leftMirror,
        "-class": "land",
        "-fill": "#888888",
        "-d": leftMirror,
        "-self-closing": "true"
      },
      {
        "-id": "13",
        "-title": DamageTypeTruckEnum.rightMirror,
        "-class": "land",
        "-fill": "#888888",
        "-d": rightMirror,
        "-self-closing": "true"
      },
      {
        "-id": "14",
        "-title": DamageTypeTruckEnum.tireFrontRight,
        "-class": "land",
        "-fill": "#888888",
        "-d": tireFrontRight,
        "-transform": "matrix(1.83697e-16 1 1 -1.83697e-16 3210 980)",
        "-self-closing": "true"
      },
      {
        "-id": "15",
        "-title": DamageTypeTruckEnum.tireMiddleRight,
        "-class": "land",
        "-fill": "#888888",
        "-d": tireMiddleRight,
        "-transform": "matrix(1.83697e-16 1 1 -1.83697e-16 3210 1750)",
        "-self-closing": "true"
      },
      {
        "-id": "16",
        "-title": DamageTypeTruckEnum.tireRearRight,
        "-class": "land",
        "-fill": "#888888",
        "-d": tireRearRight,
        "-transform": "matrix(1.83697e-16 1 1 -1.83697e-16 3210 2077)",
        "-self-closing": "true"
      },
      {
        "-id": "17",
        "-title": DamageTypeTruckEnum.sidepanelRearRight,
        "-class": "land",
        "-fill": "#888888",
        "-d": sidepanelRearRight,
        "-transform": "matrix(1.83697e-16 1 1 -1.83697e-16 2773 1065)",
        "-self-closing": "true"
      },
      {
        "-id": "18",
        "-title": DamageTypeTruckEnum.doorFrontRight,
        "-class": "land",
        "-fill": "#888888",
        "-d": doorFrontRight,
        "-transform": "matrix(1.83697e-16 1 1 -1.83697e-16 2765 841)",
        "-self-closing": "true"
      },
      {
        "-id": "19",
        "-title": DamageTypeTruckEnum.fenderFrontRight,
        "-class": "land",
        "-fill": "#888888",
        "-d": fenderFrontRight,
        "-transform": "matrix(1.83697e-16 1 1 -1.83697e-16 2774 750)",
        "-self-closing": "true"
      },
      {
        "-id": "20",
        "-title": DamageTypeTruckEnum.roof,
        "-class": "land",
        "-fill": "#888888",
        "-d": roofRight,
        "-transform": "matrix(1.83697e-16 1 1 -1.83697e-16 2530 767)",
        "-self-closing": "true"
      }
    ]
  }
};
